export default "__VITE_ASSET__BirvCBrZ__"